export default __webpack_public_path__ + "static/media/om-logo.0c262293.svg";